import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { CreateRelocationPageInput } from "@/gql/graphql";
import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { TextAreaInput } from "@/lib/Components/Form/Inputs/TextAreaInput";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { createRelocationPageMutation } from "@/app/Settings/Admin/RelocationPages/queries/relocationPageMutations";
import { LocationRadiusInput } from "@/app/Settings/Admin/RelocationPages/Components/LocationRadiusSelector";
import { RegionInput } from "@/app/Common/Components/RegionInput";

export function CreateRelocationPageDialog() {
  const { close } = useDialogState();
  const { mutateAsync } = useGqlMutation(createRelocationPageMutation);

  return (
    <BaseDialog title="Create Relocation Page">
      <GenericForm<CreateRelocationPageInput>
        initialValues={{
          title: "",
          description: "",
          slug: "",
          points: [],
          region: null!,
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            input: values,
          });
          await close();
        }}
      >
        <TextInput name="title" label="Title" className="col-span-6" />
        <TextInput
          name="slug"
          label="Slug"
          description="i.e. brisbane-to-sydney"
        />
        <RegionInput name="region" label="Region" />

        <TextAreaInput
          name="description"
          label="Description"
          className="col-span-full"
        />

        <LocationRadiusInput name="points" className="col-span-full" />

        <DialogSubmitButton text={"Create"} />
      </GenericForm>
    </BaseDialog>
  );
}
